module.exports = __webpack_public_path__ + "static/media/eye.f2539def.svg";